export class RouteData {
	id: number;
	title: string;
	path: string;
	pathMatch?: 'full' | 'prefix';
	redirectTo?: string;
	outlet?: string;
	modulePath?: string;
	name?: string;
	parentId?: number;
	guards?: string;
	children?: RouteData[];

	constructor(properties?: {
		id?: number,
		title?: string,
		path?: string,
		pathMatch?: 'full' | 'prefix',
		redirectTo?: string,
		outlet?: string,
		modulePath?: string,
		name?: string,
		parentId?: number,
		guards?: string,
		children?: RouteData[]
	}) {
		this.id = properties?.id;
		this.title = properties?.title;
		this.path = properties?.path;
		this.pathMatch = properties?.pathMatch;
		this.redirectTo = properties?.redirectTo;
		this.outlet = properties?.outlet;
		this.modulePath = properties?.modulePath;
		this.name = properties?.name;
		this.parentId = properties?.parentId;
		this.guards = properties?.guards;
		this.children = properties?.children;
	}
}
